import {useTranslation} from 'react-i18next';

import {Collapse, Grid} from '@mui/material';

import {companyMatchText} from '../../../../../../lib/constants';
import {extractPercentAsNumber} from '../../../../../../utils/extractPercentAsNumber';
import {CultureMatchItem} from '../../../../../applicant/dashboard/types/ApplicantMatchesTypes';
import {CultureComparison} from '../../../../../applicant/matches/components/CultureFitDetails/CultureComparison';
import {MatchLevel} from '../../../../../applicant/matches/components/CultureFitDetails/MatchLevel';

interface Props {
  percent: string;
  applicantName: string;
  collapse: boolean;
  items?: CultureMatchItem[];
}

export const CollapsedMatchCultureInfo = ({percent, applicantName, collapse, items}: Props) => {
  const {t} = useTranslation();

  return (
    <Collapse in={collapse} orientation='vertical'>
      <MatchLevel
        percent={extractPercentAsNumber(percent)}
        matchText={companyMatchText}
        applicantName={applicantName}
        detailedCardView
      />

      {items?.length && (
        <Grid item mt={4}>
          <CultureComparison
            cultureMatchItems={items}
            companyName={t('companyApplicants.applicantsCard.cardDetails.itemsUs')}
            applicantName={applicantName}
            detailedCardView
          />
        </Grid>
      )}
    </Collapse>
  );
};
